export interface BlogCategoryMockItem {
  id: number
  name: string
  path: string
  postsCount: number
  description?: string
  seoTitle?: string
  seoDescription?: string
}

export const blogCategories: BlogCategoryMockItem[] = [
  { id: 1, name: 'Product Updates', path: '/product-updates', postsCount: 12 },
  { id: 2, name: 'Growth Marketing', path: '/growth-marketing', postsCount: 8 },
  { id: 3, name: 'Automation', path: '/automation', postsCount: 5 },
  { id: 4, name: 'Case Studies', path: '/case-studies', postsCount: 3 },
  { id: 5, name: 'Product Updates', path: '/product-updates', postsCount: 12 },
  { id: 6, name: 'Growth Marketing', path: '/growth-marketing', postsCount: 8 },
  { id: 7, name: 'Automation', path: '/automation', postsCount: 5 },
  { id: 8, name: 'Case Studies', path: '/case-studies', postsCount: 3 },
  { id: 9, name: 'Product Updates', path: '/product-updates', postsCount: 12 },
  {
    id: 10,
    name: 'Growth Marketing',
    path: '/growth-marketing',
    postsCount: 8,
  },
  { id: 11, name: 'Automation', path: '/automation', postsCount: 5 },
  { id: 12, name: 'Case Studies', path: '/case-studies', postsCount: 3 },
  { id: 13, name: 'Product Updates', path: '/product-updates', postsCount: 12 },
  {
    id: 14,
    name: 'Growth Marketing',
    path: '/growth-marketing',
    postsCount: 8,
  },
  { id: 15, name: 'Automation', path: '/automation', postsCount: 5 },
  { id: 16, name: 'Case Studies', path: '/case-studies', postsCount: 3 },
  { id: 17, name: 'Product Updates', path: '/product-updates', postsCount: 12 },
  {
    id: 18,
    name: 'Growth Marketing',
    path: '/growth-marketing',
    postsCount: 8,
  },
  { id: 19, name: 'Automation', path: '/automation', postsCount: 5 },
  { id: 20, name: 'Case Studies', path: '/case-studies', postsCount: 3 },
]
